import { render, staticRenderFns } from "./TrademarkSearchResponsibleForm.vue?vue&type=template&id=1868be52&"
import script from "./TrademarkSearchResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports